export const maritalStatus = new Map([
  ['Married', 'Getrouwd'],
  ['Unmarried', 'Ongehuwd'],
  ['Registered partnership', 'Geregistreerd Partnerschap'],
]); 
